import { PHONE_DISPLAY, INSTAGRAM_URL, whatsappLink } from "@/lib/contact";


export default function Footer() {  return (
    <footer id="contact" className="bg-ink text-cream" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <h2 className="font-serif text-4xl sm:text-6xl leading-[0.95] tracking-tight mb-8">
              Нека създадем нещо<br />
              <span className="italic text-clay">красиво</span> за вас
            </h2>
            <a
              href={whatsappLink("Здравейте, Айлян! Интересувам се от вашите цветя.")}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 border border-cream/30 rounded-full px-7 py-3.5 text-sm hover:bg-cream hover:text-ink transition-colors duration-300"
              data-testid="footer-call"
            >
              Свържете се с Айлян
            </a>
          </div>
          <div className="lg:col-span-6 grid sm:grid-cols-2 gap-10 lg:pl-12">
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-cream/50 mb-4">Контакт</p>
              <p className="font-light text-cream/80 leading-relaxed">
                {PHONE_DISPLAY}<br />
                България
              </p>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-cream/50 mb-4">Последвай ни</p>
              <div className="flex flex-col gap-2 font-light text-cream/80">
                <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="hover:text-clay transition-colors">Instagram</a>
                <a href="/admin/login" className="hover:text-clay transition-colors" data-testid="admin-link">
                  Вход за Айлян
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-cream/15 mt-20 pt-8 flex flex-col sm:flex-row justify-between gap-4 text-xs text-cream/40">
          <span>© {new Date().getFullYear()} Айлян · Изкуство от цветя</span>
          <span>Ръчно изработени вечни цветя</span>
        </div>
      </div>
    </footer>
  );
}
